import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import {getSelectedOptionLabel} from "../../../utils/options";
import {rightsRegistryRegulationsOptions} from "../../../../../common/constants/options";
import styles from './styles.module.scss';

const Section8Text11 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, rightsRegistryRegulations} = context.data.pdfData;
  const rightsRegistryRegulationsValue = getSelectedOptionLabel(rightsRegistryRegulations, rightsRegistryRegulationsOptions);

  return (
    <div ref={ref}>
      {rightsRegistryRegulationsValue && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>תקנון מצוי/ מוסכם (תנאים מיוחדים): </span>
          <span>{rightsRegistryRegulationsValue}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text11;
